import StockCrud from './StockCrud'
export {StockCrud}
export default StockCrud
